import Form from "../modules/form";

window.hcaptchaCallback = function (response) {
  window.form.submit(response);
};

const Career = {
  init() {
    window.form.form = new Form("#contact-form");
  },
};

export default Career;
